import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import * as Yup from "yup";
import { Table } from "antd";
import { toast } from "core/Operations/toast";
import { useImportEmployeesMutation } from "AppQuries/employee/import-employee";
import {
  getCurrentFormattedDate,
  parseExcelDateToISO,
} from "core/Operations/dateFormat";
import { useInsertOfferLetterMutation } from "AppQuries/employee/offer-letter";
import { encrypt } from "core/Operations/cryptHelper";
import mammoth from "mammoth";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const UploadOfferLetter = () => {
  const userData = useSelector(loggedInUser);
  const { employeeCode } = useParams();

  const [importData, setImportData] = useState([]);
  const navigate = useNavigate();

  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");

  const {
    mutate: uploadOfferLetter,
    isSubmitted,
    isSubmitting,
    isError,
    error,
  } = useInsertOfferLetterMutation();

  const [selectedFile, setSelectedFile] = useState(null);

  // Function to remove the uploaded file
  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const validateFile = (file) => {
    const allowedMimeTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const allowedExtensions = ["pdf", "docx"];

    const extension = file.name.split(".").pop().toLowerCase();

    return {
      allowFile:
        allowedMimeTypes.includes(file.type) &&
        allowedExtensions.includes(extension),
      fileType: extension,
    };
  };

  const importEmployeeData = async () => {
    console.log("selectedFile", selectedFile);
    const checkFile = validateFile(selectedFile);

    if (!checkFile.allowFile) {
      toast.warning("Please select a valid file.");
      return;
    }

    const requestData = new FormData();
    requestData.append("file", selectedFile);

    // if (checkFile.fileType === "docx") {
    //   const arrayBuffer = await selectedFile.arrayBuffer();

    //   // 1️⃣ Convert DOCX → HTML
    //   const result = await mammoth.convertToHtml({ arrayBuffer });
    //   const html = result.value;

    //   const tempDiv = document.createElement("div");
    //   tempDiv.innerHTML = html;
    //   tempDiv.style.width = "800px";
    //   document.body.appendChild(tempDiv);

    //   // 3️⃣ HTML → Canvas
    //   const canvas = await html2canvas(tempDiv);
    //   const imgData = canvas.toDataURL("image/png");

    //   // 4️⃣ Canvas → PDF
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   const imgWidth = 210;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //   pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
    //   pdf.save("converted.pdf");

    //   document.body.removeChild(tempDiv);

    //   // const reader = new FileReader();
    //   // reader.onload = async (e) => {
    //   //   const arrayBuffer = e.target.result;

    //   //   // Extract text from DOCX
    //   //   const { value } = await mammoth.extractRawText({ arrayBuffer });
    //   //   console.log("value", value);
    //   //   // Create PDF
    //   //   const doc = new jsPDF();
    //   //   doc.text(value, 10, 10);

    //   //   // Download PDF
    //   //   // doc.save("converted.pdf");
    //   // };
    //   // reader.readAsArrayBuffer(selectedFile);
    //   // console.log(reader);
    //   // requestData.append("file", reader.result);
    // }
    const payload = {
      companyCode: userData?.companyCode,
      employeeCode: Number(employeeCode),
      user: userData?.userName,
      date: getCurrentFormattedDate(),
    };

    requestData.append("data", JSON.stringify(payload));

    // console.log("selectedFile", selectedFile);

    uploadOfferLetter(requestData, {
      onSuccess: (data) => {
        if (data?.response === true) {
          toast.success(data?.message);
          navigate(-1);
        } else {
          toast.warning(data?.message);
        }
      },

      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
      },
    });
    setSelectedFile(null);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Upload Offer Letter</h4>
              {/* <h6>Add Employees Allowance And Deduction from excel sheet</h6> */}
            </div>
          </div>

          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                // to={`${all_routes.employee}${all_routes.employee_offer_letter}`}
                to={`${all_routes.employee}${
                  all_routes.employee_offer_letter
                }?companyCode=${encrypt(
                  userData?.companyCode
                )}&employeeCode=${encrypt(employeeCode)}`}
                className="btn btn-secondary"
              >
                {/* <ArrowLeft className="me-2" /> */}
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row form-row">
              <div className="col-lg-12">
                <div className="modal-footer-btn download-file mb-3">
                  <button
                    // onClick={handleDownloadSample}
                    onClick={importEmployeeData}
                    className="btn btn-submit"
                    type="button"
                    disabled={isSubmitting || isSubmitted}
                  >
                    Import
                  </button>
                </div>
              </div>

              <>
                <div className="col-lg-12">
                  <div className="input-blocks image-upload-down mb-10">
                    <label> Upload Offer Letter</label>
                    <div className="image-upload download">
                      {!selectedFile ? (
                        <>
                          <input
                            type="file"
                            // accept=".xlsx, .xls"

                            onChange={(e) => {
                              setSelectedFile(e.target.files[0]);
                            }}
                            accept=".pdf,.docx"
                          />
                          <div className="image-uploads">
                            <ImageWithBasePath
                              src="assets/img/download-img.png"
                              alt="img"
                            />
                            <h4>
                              Drag and drop a <span>file to upload</span>
                            </h4>
                          </div>
                        </>
                      ) : (
                        <div className="uploaded-file-info">
                          <div className="image-uploads">
                            <p>Uploaded File: {selectedFile?.name}</p>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={handleRemoveFile}
                            >
                              Remove File
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12" style={{ marginTop: "75px" }}>
                  {uploadStatus && (
                    <div
                      className={`alert ${
                        uploadStatus.includes("Successfully")
                          ? "alert-success"
                          : "alert-info"
                      } mt-3`}
                    >
                      {uploadStatus}
                    </div>
                  )}
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOfferLetter;
